
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-19719.375 6816.25 16.148 16.147"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 7163","transform":"translate(-19718.625 6817)"}},[_c('circle',{attrs:{"cx":"7.324","cy":"7.324","r":"7.324","data-name":"Ellipse 903","fill":"none","stroke":"#f44336","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M6.676 8.361a.684.684 0 0 0 .583.583.589.589 0 0 0 .518-.259 2.06 2.06 0 0 0 .194-.583c.065-.778.324-3.241.389-3.824a3.123 3.123 0 0 0 0-.778 1.033 1.033 0 0 0-.583-.778 1.261 1.261 0 0 0-.972 0 1.273 1.273 0 0 0-.583 1.1 4.853 4.853 0 0 0 .065.64c.047.261.259 2.6.323 3.572.034.149.066.327.066.327zm.648 1.426a1.07 1.07 0 0 0-.065 2.139 1.055 1.055 0 0 0 1.1-1.1.986.986 0 0 0-1.037-1.039z","data-name":"Path 3523","fill":"#f44336"}})])])
          )
        }
      }
    